var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "103.02061093673014 -4.003289536655417 20.101100645280752 18.684059481239967",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M113.42,0c.73.26,2.21.55,3.43,1.27,2.99,1.76,3.02,5.27.14,7.16-.97.64-2,1.22-3.04,1.73-2.16,1.06-4.47.47-5.82-1.48-1.27-1.83-1.49-3.78-.45-5.8.98-1.9,2.82-2.95,5.74-2.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle111);
export default __webpack_public_path__ + "static/media/twinkle-1-11.034cd0e94400db9fb32727837237291a.svg";
export { ForwardRef as ReactComponent };